export const COMPILATION = { id: 'compilation', label: 'In compilazione' };
export const TO_VALIDATE = { id: 'to_validate', label: 'Da validare' };
export const VALIDATED = { id: 'validated', label: 'Validata' };
export const REJECTED = { id: 'rejected', label: 'Eliminata' };
